import { render, staticRenderFns } from "./GsCalendarItem.vue?vue&type=template&id=97c05a6a&scoped=true"
import script from "./GsCalendarItem.vue?vue&type=script&lang=js"
export * from "./GsCalendarItem.vue?vue&type=script&lang=js"
import style0 from "./GsCalendarItem.vue?vue&type=style&index=0&id=97c05a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c05a6a",
  null
  
)

export default component.exports